<template>
  <div class="flex flex-col gap-4">
    <div v-if="locations" v-for="(location, index) in locations">
      <input
        type="checkbox"
        name="locationCode"
        class="peer hidden"
        :id="location.id"
        :key="location.id"
        :value="location.roomTypeCode"
        :checked="internalValue === location.id"
        @change="onChange(location.roomTypeCode, location.id, location.parentId)"
      />
      <Label :val="location.roomTypeCode" :id="location.id" :name="location.name" :internalValue="internalValue" :onChange="onChange" />
    </div>
  </div>
</template>

<script>
import Label from '@/components/ui/label';


export default {
  name: 'ChooseLocation',
  components: { Label },
  props: {
    areaCode: {
      type: String,
      required: true,
    },
    locationCode: {
      type: String,
      required: true,
    },
    id: {
      required: true,
    },
    value: {
      required: false,
    },
    dir: {
      required: false,
    }
  },
  data() {
    return {
      showLoader: true,
      internalValue: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = value;
      },
    },
  },
  computed: {
    /**
     * Locations. T.ex. Kök, badrum...
     *
     * Filtrerat på vilken area man valt.
     */
    locations() {

      let rooms = this.$store.getters.getErrorReportAreas;

      //Gruppera baserat på roomTypeCode
      const groups = rooms.reduce((acc, room) => {
        acc[room.roomTypeCode] = acc[room.roomTypeCode] || [];
        acc[room.roomTypeCode].push(room);
        return acc;
      }, {});

      //Loopa igenom och ta bort siffran om det bara finns 1 rum i gruppen
      return rooms.map(room => {
        const group = groups[room.roomTypeCode];

        if (group.length === 1) {
          // Ta bort eventuell siffra i slutet, tex "Sovrum 1" -> "Sovrum"
          return {
            ...room,
            name: room.name.replace(/\s\d+$/, "")
          };
        }

        return room;
      });
    },
  },
  methods: {
    onChange(value, id, parentId = null) {
      // Om användaren klickar på samma val igen → avmarkera
      if (this.internalValue === id) {
        this.internalValue = null;
        this.$emit('update:locationCode', null);
        this.$emit('update:id', null);
        this.$emit('update:hasBottomNode', null);
        this.$emit('change', null);
      } else {
        // Annars sätt nytt värde
        this.internalValue = id;
        if (this.areaCode === 'apartment') {
          this.$emit('update:locationCode', value);
          this.$emit('update:id', id);
          this.$emit('change', value);
        }
        else {
          this.$emit('update:locationCode', id);
          this.$emit('update:id', id);
          this.$emit('change', id);
        }

        this.$emit('update:hasBottomNode', true);
      }
    },
  },
  created() {
    this.internalValue = this.id;

    if (this.locationCode && this.dir =="prev"){
      this.$emit('update:locationCode', this.locationCode);
      this.$emit('change', this.locationCode);
    }
  },
};
</script>
